import React from 'react';
import type { ControlProps, GroupBase, Props } from 'react-select';
import { components } from 'react-select';

import type { SelectOption } from 'js/src/components/common/ui/Select/types';

interface CustomSelectProps<
    Option,
    IsMulti extends boolean,
    Group extends GroupBase<Option>,
> extends Props<Option, IsMulti, Group> {
    iconLeft?: string | React.ReactNode;
}

const CustomControl = <
    T = unknown,
    Option extends SelectOption<T> = SelectOption<T>,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
>(
    props: ControlProps<Option, IsMulti, Group> & {
        selectProps: CustomSelectProps<Option, IsMulti, Group>;
    },
) => {
    const { iconLeft } = props.selectProps;
    const iconLeftComponent =
        typeof iconLeft === 'string' ? (
            <i className="material-symbols-outlined my-l5-4">{iconLeft}</i>
        ) : (
            iconLeft
        );

    return (
        <components.Control {...props}>
            {iconLeftComponent && <div className="ms-l5-8">{iconLeftComponent}</div>}
            {props.children}
        </components.Control>
    );
};

export default CustomControl;
